import React from "react";
import { useTV } from "../../hooks/useTV";

const RespMessage = ({ msg }) => {
  const { isTv } = useTV();

  return (
    <div>
      {msg === "Ride Closed" ? (
        <span style={{ fontSize: isTv ? "40px" : "28px" }}>
          Ride <br /> Closed
        </span>
      ) : null}
      {msg === "No Wait" ? (
        <span style={{ fontSize: isTv ? "40px" : "28px" }}>
          No <br /> Wait
        </span>
      ) : null}
    </div>
  );
};

export default RespMessage;
